import ApiService from 'services/ApiService';
import { httpClient } from 'utils/http';

// No ShopIntegrationModel exists in @sosocio/creator/interfaces, so the
// shape is defined locally with the fields displayed by the Shops module.
export interface ShopIntegrationModel {
	id: number;
	name: string;
	integrationType: string;
	created: string;
}

// Detail response from /api/shop-integration/:id — known fields are typed,
// but any extra fields the API returns are kept and rendered too.
export interface ShopIntegrationDetailModel extends ShopIntegrationModel {
	cartUrl: string | null;
	fileDeliveryUrl: string | null;
	fileDeliveryApiKey: string | null;
	apiKey: string | null;
	priceMultiplier: string | number | null;
	styling: string | null;
	pmsLicenseKey: string | null;
	app: string | null;
	[key: string]: unknown;
}

class ShopIntegrationService extends ApiService<ShopIntegrationModel> {
	constructor() {
		super('shop');
	}

	// List reads use /api/shop, but the detail read goes through /api/shop-integration.
	async getIntegration(id: string | number): Promise<ShopIntegrationDetailModel> {
		const response = await httpClient.get(`/api/shop-integration/${id}`);
		return response.data;
	}

	async updateIntegration(id: string | number, item: Partial<Omit<ShopIntegrationDetailModel, 'id'>>): Promise<ShopIntegrationDetailModel> {
		const response = await httpClient.put(`/api/shop-integration/${id}`, item);
		return response.data;
	}

	// Invalidates the current API key and generates a new one.
	async rotateApiKey(id: string | number): Promise<ShopIntegrationDetailModel> {
		const response = await httpClient.put(`/api/shop-integration/${id}/apikey`);
		return response.data;
	}

	// Reads use /api/shop, but creation goes through /api/shop-integration.
	async createIntegration(item: { name: string; integrationType: string }): Promise<ShopIntegrationModel> {
		const response = await httpClient.post('/api/shop-integration', item);
		return response.data;
	}
}

export default new ShopIntegrationService();
